import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Training from './pages/Training';
import Projects from './pages/Projects';
import CommunityNotes from './pages/CommunityNotes';
import Fundraiser from './pages/Fundraiser';
import About from './pages/About';
import Yuki from './pages/Yuki';
import './styles/GlobalStyles.css';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/training" element={<Training />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/community-notes" element={<CommunityNotes />} />
        <Route path="/fundraiser" element={<Fundraiser />} />
        <Route path="/about" element={<About />} />
        <Route path="/yuki" element={<Yuki />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;